var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.082 31.082",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8,3.3c0.3-0.3,0.4-0.8,0.4-0.8s0,0.5,0.4,0.8c0.3,0.3,0.8,0.4,0.8,0.4s-0.4,0.1-0.8,0.4c-0.3,0.3-0.4,0.8-0.4,0.8 s0-0.5-0.4-0.8C11.4,3.8,11,3.7,11,3.7S11.4,3.7,11.8,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,4.7c0.2-0.2,0.2-0.4,0.2-0.4s0,0.2,0.2,0.4c0.2,0.2,0.4,0.2,0.4,0.2s-0.2,0-0.4,0.2c-0.2,0.2-0.2,0.4-0.2,0.4 s0-0.2-0.2-0.4C10.2,4.9,10,4.9,10,4.9S10.2,4.9,10.3,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,5.5c0.1-0.1,0.1-0.2,0.1-0.2s0,0.1,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1s-0.1,0-0.2,0.1C11.5,5.8,11.5,6,11.5,6 s0-0.1-0.1-0.2c-0.1-0.1-0.2-0.1-0.2-0.1S11.3,5.6,11.4,5.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.4,8.5 18.5,8.5 15,3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.4,20.8 10.2,20.8 10.2,26.4 10,26.4 10,25.2 7,25.2 7,26.4 6.8,26.4 6.8,20.8 3.5,20.8 0,26.4 29.9,26.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20.8,
    width: 3,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 16.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 17.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 18.2,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.4,20.4 26.1,20.4 22.6,14.9 13.4,14.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,14.9 7.3,14.9 3.8,20.4 10,20.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 14.9,
    width: 3,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 19.3,
    width: 3,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 12.3,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.7,14.5 22.3,14.5 18.8,8.9 16.7,8.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 11.3,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.2,8.9 11.1,8.9 7.6,14.5 13.2,14.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 10.3,
    width: 3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 13.3,
    width: 3,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 8.9,
    width: 3,
    height: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill0);
export default __webpack_public_path__ + "static/media/skill0.10fea3b4.svg";
export { ForwardRef as ReactComponent };